import styled from 'styled-components';

import { theme } from '../../../../global';

export const StyledPauseButton = styled.button`
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background-color: ${theme.colors.pause};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
  box-shadow: 0 0 15px ${theme.colors.shadow_primary};

  &:hover {
    transform: scale(1.05);
  }

  &:disabled {
    opacity: 0.8;
    cursor: default;
    transform: scale(1);
  }
`;
